import React from 'react';
import ShowChart from '@material-ui/icons/ShowChart';
import Share from '@material-ui/icons/Share';
import AllInbox from '@material-ui/icons/AllInbox';
import Store from '@material-ui/icons/Store';
import AddComment from '@material-ui/icons/AddComment';
import People from '@material-ui/icons/People';
import DriveEta from '@material-ui/icons/DriveEta';
import NearMe from '@material-ui/icons/NearMe';
import ShoppingCart from '@material-ui/icons/ShoppingCart';
import Settings from '@material-ui/icons/Settings';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import EuroSymbolIcon from '@material-ui/icons/EuroSymbol';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import MapIcon from '@material-ui/icons/Map';
import PrintIcon from '@material-ui/icons/Print';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import { UNIT } from './theme';
import {
  HUBRISE_ROUTE,
  GENERAL_CONFIG_ROUTE,
  SALES_TYPE_ROUTE,
  PAYMENTS_ROUTE,
  PRINTER_ROUTE,
  DELIVERY_ZONE_ROUTE,
  OPENED_HOUR_ROUTE,
  DELIVERY_HOUR_ROUTE,
  SPECIFIC_HOUR_ROUTE,
  DELIVERY_SETTINGS_ROUTE,
  ORDER_SETTINGS_ROUTE,
  GENERAL_DESIGN_ROUTE,
  WEB_DESIGN_ROUTE,
  MOBILE_DESIGN_ROUTE,
  PUSH_NOTIF_ROUTE,
  CODE_PROMO_ROUTE,
  FEDILITY_PROGRAM_ROUTE,
  ACTIVATION_ROUTE,
  MANAGEMENT_FEE_ROUTE,
  DEEPLINK_ROUTE
} from './routes';
import webDesignIcon from '../assets/pictures/webDesignIcon.png';
import designIcon from '../assets/pictures/designIcon.png';
import mobileIcon from '../assets/pictures/mobileIcon.png';
import fidelityIcon from '../assets/pictures/fidelityIcon.png';
import magicWand from '../assets/pictures/magicWand.png';
import StarOutlineOutlinedIcon from '@material-ui/icons/StarOutlineOutlined';
import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined';
const iconStyle = {
  marginRight: UNIT * 0.625,
  fontSize: UNIT * 0.8125,
  lineHeight: UNIT * 0.8125
};

const webIcon = {
  width: UNIT * 1.1875,
  opacity: 0.7
};
const magicWandIcon = {
  width: UNIT * 1.8125,
  opacity: 0.7
};
export const gestion = {
  text: 'Gestion & Données',
  listItems: [
    {
      text: 'Commandes',
      url: '/',
      icon: <ShoppingCart style={iconStyle} />
    },
    {
      text: 'Finances',
      url: '/finances',
      icon: <ShowChart style={iconStyle} />
    },
    {
      text: 'Ventes / Stocks',
      url: '/sales',
      icon: <AllInbox style={iconStyle} />
    },
    { text: 'Livreurs', url: '/livreurs', icon: <DriveEta style={iconStyle} /> },
    { text: 'Clients', url: '/clients', icon: <People style={iconStyle} /> },
    { text: 'Support', url: '/support', icon: <LiveHelpIcon style={iconStyle} /> },
    {
      text: 'Factures',
      url: '/invoice',
      icon: <DescriptionOutlinedIcon style={iconStyle} />
    }
  ]
};

export const applicationMobile = {
  text: 'Applications',
  listItems: [
    {
      text: 'Produits',
      url: '/products',
      icon: <Store style={iconStyle} />
    },
    {
      text: "Liste d'options",
      url: '/options-products',
      icon: <AddComment style={iconStyle} />
    },

    {
      text: 'Réglages',
      url: '/settings',
      icon: <Settings style={iconStyle} />
    }
  ]
};
export const settings = {
  general: {
    text: 'Paramètres du magasin',
    url: GENERAL_CONFIG_ROUTE,
    icon: <Store />,
    description: 'Modifiez les informations générales de votre magasin.'
  },
  orderSettings: {
    text: 'Paramètres des commandes',
    url: ORDER_SETTINGS_ROUTE,
    icon: <Store />,
    description: 'Modifiez les paramètres des commandes.'
  },
  openedHours: {
    text: "Horaires d'ouverture",
    url: OPENED_HOUR_ROUTE,
    icon: <AccessTimeIcon />,
    description: "Modifiez vos horaires d'ouverture et le maximum de commandes par créneau."
  },
  deliveryHours: {
    text: 'Horaires de livraison',
    url: DELIVERY_HOUR_ROUTE,
    icon: <DirectionsBikeIcon />,
    description: 'Modifiez vos horaires de livraison et le maximum de commandes par créneau.'
  },
  paymentTypes: {
    text: 'Modes de paiement',
    url: PAYMENTS_ROUTE,
    icon: <EuroSymbolIcon />,
    description: 'Activez ou désactivez les modes de paiement associés à vos technologies.'
  },

  orderTypes: {
    text: 'Modes de vente',
    url: SALES_TYPE_ROUTE,
    icon: <TouchAppIcon />,
    description: 'Activez ou désactivez les modes de vente associés à vos technologies.'
  },
  deliveryZone: {
    text: 'Zones de livraison',
    url: DELIVERY_ZONE_ROUTE,
    icon: <MapIcon />,
    description:
      "Définissez le minimum d'achat et les frais de livraison pour vos zones de livraison."
  },
  DeliverySettings: {
    text: 'Paramètres des frais de livraison par kilomètre',
    url: DELIVERY_SETTINGS_ROUTE,
    icon: <DriveEta />,
    description:
      'Définissez vos frais de livraison pour chaque palier de distance et pour chaque kilomètre parcouru.'
  },
  specificHours: {
    text: 'Horaires spécifiques',
    url: SPECIFIC_HOUR_ROUTE,
    icon: <CalendarTodayIcon />,
    description: "Définissez des horaires d'ouverture ou de fermeture exceptionnelles."
  },
  hubrise: {
    text: 'Paramètres HubRise',
    url: HUBRISE_ROUTE,
    icon: <Settings />,
    description: 'Connectez-vous ou déconnectez-vous de votre compte HubRise.'
  },
  printers: {
    text: 'Imprimantes',
    url: PRINTER_ROUTE,
    icon: <PrintIcon />,
    description: 'Connectez votre imprimante.'
  },
  managementFee: {
    text: 'Paramétres des frais de gestion',
    url: MANAGEMENT_FEE_ROUTE,
    icon: <Settings />,
    description: 'Vous pouvez configurer vos frais de gestion par mode de vente'
  }
};
export const marketingItems = {
  text: 'Marketing',
  listItems: [
    {
      text: 'Marketing',
      url: '/marketing',
      icon: <LocalOfferIcon style={iconStyle} />
    },
    {
      text: 'Assistance',
      url: '/salesService',
      icon: <ContactSupportOutlinedIcon style={iconStyle} />
    }
  ]
};

export const marketing = {
  pushNotification: {
    text: 'Push notification',
    url: PUSH_NOTIF_ROUTE,
    icon: <NearMe />,
    description: 'Communiquez en direct avec tous vos clients grâce aux push notifications. '
  },
  codePromo: {
    text: 'Code promotionnel',
    url: CODE_PROMO_ROUTE,
    icon: <Share />,
    description: 'Créer et mettre en place des codes promotionnels personnalisés. '
  },
  general: {
    text: 'Design général',
    url: GENERAL_DESIGN_ROUTE,
    icon: <img src={designIcon} alt='displayImage' style={webIcon} />,
    description: 'Configurez le design général de votre site web et de votre application mobile. '
  },
  webDesign: {
    text: 'Design site web',
    url: WEB_DESIGN_ROUTE,
    icon: <img src={webDesignIcon} alt='displayImage' style={webIcon} />,
    description: 'Personnalisez les éléments visuels de votre site web. '
  },
  mobileDesign: {
    text: 'Design application mobile',
    url: MOBILE_DESIGN_ROUTE,
    icon: <img src={mobileIcon} alt='displayImage' style={webIcon} />,
    description: 'Personnalisez les éléments visuels de votre application mobile. '
  },
  fidelityProgram: {
    text: 'Cagnotte fidélité',
    url: FEDILITY_PROGRAM_ROUTE,
    icon: <img src={fidelityIcon} alt='displayImage' style={webIcon} />,
    description: 'Définissez le programme fidélité à proposer à vos clients. '
  },
  activation: {
    text: 'Programme de bienvenue',
    url: ACTIVATION_ROUTE,
    icon: <StarOutlineOutlinedIcon />,
    description: 'Souhaitez la bienvenue à vos utilisateurs en leur envoyant une push notification personnalisée après l’installation de votre application mobile. '

  },
  deepLinks: {
    text: 'Liens magiques',
    url: DEEPLINK_ROUTE,
    icon: <img src={magicWand} alt='displayImage' style={magicWandIcon} />,
    description: `Créez un lien magique et suivez les performances de vos campagnes marketing.`
  },
};